import React, { useEffect } from "react";
import { Alert, AlertTitle, Box } from "@vapor/react-material";
import Typography from "@vapor/react-extended/ExtendedTypography";

const DeleteAlert = ({ deletedCount, onClose, duration = 9000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(); // Trigger the onClose callback to hide the alert
    }, duration);

    return () => clearTimeout(timer); // Cleanup timer
  }, [duration, onClose]);
  console.log("componenet render");
  return (
    <Box
      sx={{
        position: "fixed",
        top: "16px",
        right: "16px",
        zIndex: 1800, // Ensure it appears above other elements
        maxWidth: "300px",
        width: "100%",
        padding: "10px",
      }}
    >
      <Alert
        sx={{
          backgroundColor: "#E8F5E9", // Light green background
          border: "1px solid #4CAF50", // Green border
          borderRadius: "8px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
        }}
        variant="outlined"
        severity="success"
        icon={false}
      >
        <AlertTitle>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: "18px",
              fontWeight: "600",
              color: "#4CAF50",
            }}
          >
            Successo!
          </Typography>
        </AlertTitle>
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            color: "#2E7D32",
          }}
        >
          {`${deletedCount} elemento${deletedCount > 1 ? "i" : ""} eliminato${
            deletedCount > 1 ? "i" : ""
          } con successo.`}
        </Typography>
      </Alert>
    </Box>
  );
};

export default DeleteAlert;
